import type { AgentControlDefinition } from "./types";

export const editorDefinitions: AgentControlDefinition[] = [
  {
    name: "toggleAdminDebugPanel",
    description: "Toggle the admin debug panel (tabbed panel with debug tools)",
  },
  {
    name: "toggleAgentConnectionDebugPanel",
    description:
      "Toggle the agent connection debug panel (shows agent state, events, logs)",
  },
];
